import React from 'react'
import CheckIcon from '@mui/icons-material/Check';

type Props = {
    label: string;
    subLabel?: string;
    disableCheckBox?: boolean;
    checked?: boolean;
    subLabelClassName?: string;
    labelClassName?: string;
    detailLabel?: string;
    align?: string
    containerClassName?: string;
    disabledLabel?: boolean;
    labelBolder?:boolean;
}

const CheckBoxReport: React.FC<Props> = ({ label, subLabel, disableCheckBox, checked, subLabelClassName, labelClassName, detailLabel, align, containerClassName, disabledLabel,labelBolder }: Props) => {
    return (
        <section className={`flex justify-${align ? align : 'start'} ${containerClassName && containerClassName} items-center gap-4`}>
            {!disableCheckBox && (
                <article className={`w-[1.3rem] h-[1.3rem] border-[1px] flex justify-center items-center border-[#000]`}>
                    {checked && (
                        <CheckIcon sx={{ fontSize: "1rem" }} />
                    )}
                </article>
            )}
            {!disabledLabel && (
                <article className='flex flex-col'>
                    <span className={`text-[1rem] font-normal flex ${labelClassName}`}>
                        <div className='flex gap-3'>
                            <div className={`${labelBolder && 'font-semibold'}`}> {label}</div>
                            {detailLabel && <div>{detailLabel}</div>}
                        </div>
                    </span>
                    {subLabel && (
                        <span className={`mt-[-0.6rem] ${subLabelClassName && subLabelClassName}`}>
                            {subLabel}
                        </span>
                    )}
                </article>
            )}

        </section>
    )
}

export default CheckBoxReport